<!-- <template>
    <AppLayout>
        <div class="container p-4 mx-auto md:px-1 md:py-4"> -->
<!-- breadcrumb -->
<!-- <nav
                class="mb-6 text-sm font-semibold"
                aria-label="Breadcrumb"
            >
                <ol class="inline-flex p-0 list-none">
                    <li class="flex items-center text-blue-500">
                        <inertia-link
                            :href="route('landing')"
                            class="text-gray-600"
                        >
                            {{ $t('LBL_HOME') }}
                        </inertia-link>
                        <svg
                            fill="#34D399"
                            class="w-3 h-3 mx-3"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                        >
                            <path
                                d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                            />
                        </svg>
                    </li>
                    <li class="flex items-center">
                        <a
                            href="#"
                            class="text-gray-600"
                            >Stock History</a
                        >
                    </li>
                </ol>
            </nav> -->
<!-- breadcrumb end -->
<template>
    <AppLayout>
        <div class="max-w-7xl mx-auto px-4 py-6">
            <!-- Page Title -->
            <div class="mb-6">
                <h1 class="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                    {{ $tc('LBL_STOCK_HISTORY', 1) }}
                </h1>
                <!-- Breadcrumb -->
                <nav
                    class="text-sm text-gray-500 mb-6"
                    aria-label="Breadcrumb"
                >
                    <ol class="flex items-center space-x-2">
                        <li class="flex items-center">
                            <inertia-link
                                :href="route('landing')"
                                class="text-green-600 hover:underline"
                            >
                                {{ $t('LBL_HOME') }}
                            </inertia-link>
                            <svg
                                class="w-3 h-3 mx-2 text-green-400"
                                fill="currentColor"
                                viewBox="0 0 320 512"
                            >
                                <path
                                    d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                                />
                            </svg>
                        </li>
                        <li class="text-gray-700">
                            {{ $tc('LBL_STOCK_HISTORY', 1) }}
                        </li>
                    </ol>
                </nav>
            </div>
            <!-- breadcrumb end -->

            <!-- <div class="flex items-center justify-between my-6">
                <div class="text-xl font-bold">
                    Stock History
                </div>

                <div class="flex">
                    <div>
                        <input
                            v-model="search"
                            class="w-full h-10 px-3 py-1 border border-gray-300 rounded-lg focus:bg-gray-50 focus:outline-none focus:shadow-outline "
                            placeholder="Search Product"
                        >
                    </div>
                    <div v-if="!isWholesaler">
                        <t-select
                            v-model="filterBy"
                            placeholder="All"
                            :options="wholesalers"
                            text-attribute="name"
                            value-attribute="id"
                        />
                    </div>
                </div>
            </div> -->

            <!-- <div class="p-4 max-w-full bg-white rounded-lg border shadow-md sm:p-6 dark:bg-gray-800 dark:border-gray-700">

                <div class="py-4">
                    <label
                        for="table-search"
                        class="sr-only"
                    >Search</label>
                    <div class="relative mt-1">
                        <div class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                            <svg
                                class="w-5 h-5 text-gray-500 dark:text-gray-400"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            ><path
                                fill-rule="evenodd"
                                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                clip-rule="evenodd"
                            /></svg>
                        </div>
                        <t-input
                            id="stock-history-search-box"
                            v-model="search"
                            type="text"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-80 pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                            placeholder="Search for product"
                            @keypress.enter="fetchSearchResults()"
                        />
                    </div>
                    <div v-if="!isWholesaler">
                        <t-select
                            v-model="filterBy"
                            placeholder="All"
                            :options="wholesalers"
                            text-attribute="name"
                            value-attribute="id"
                        />
                </div> -->

            <!-- <div class="p-0 max-w-full bg-white rounded border shadow-md sm:p-0 dark:bg-gray-800 dark:border-gray-700">
                <div class="flex items-center justify-between p-2">
                    <div class="py-0">
                        <label
                            for="table-search"
                            class="sr-only"
                            >Search</label
                        >
                        <div class="relative mt-1">
                            <div class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                                <svg
                                    class="w-5 h-5 text-gray-500 dark:text-gray-400"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <t-input
                                id="stock-search-box"
                                v-model="search"
                                type="text"
                                variant="success"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-80 pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                placeholder="Search for products"
                                @keypress.enter="fetchSearchResults()"
                            />
                        </div>
                    </div>

                    <div
                        v-if="isAdmin"
                        class="flex w-1/3"
                    >
                        <label
                            for="table-search"
                            class="flex items-center mr-2 text-sm font-semibold"
                        >
                            Wholesaler
                        </label>
                        <t-select
                            v-model="filterBy"
                            placeholder="All"
                            :options="wholesalers"
                            text-attribute="name"
                            value-attribute="id"
                            class="text-sm"
                        />
                    </div>
                </div> -->

            <div
                class="w-full bg-white dark:bg-gray-900 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 overflow-overflow"
            >
                <!-- Search & Action Bar -->
                <div class="flex flex-wrap items-center justify-between gap-4 p-4 sm:flex-nowrap">
                    <!-- Search Box -->
                    <div class="relative w-full sm:w-auto">
                        <label
                            for="table-search"
                            class="sr-only"
                            >Search</label
                        >
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg
                                class="w-5 h-5 text-gray-500 dark:text-gray-400"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </div>
                        <t-input
                            id="product-search-box"
                            v-model="search"
                            type="text"
                            variant="success"
                            class="w-full sm:w-80 pl-10 pr-4 py-2.5 text-sm rounded-lg border border-gray-300 focus:ring-1 focus:ring-green-500 focus:outline-none dark:bg-gray-800 dark:border-gray-600 dark:text-white"
                            placeholder="Search for product"
                            @keypress.enter="fetchPageData()"
                        />
                    </div>

                    <!-- Action Buttons -->
                    <div
                        v-if="isAdmin"
                        class="flex gap-2 w-1/3"
                    >
                        <!-- <div
                            v-if="isAdmin"
                            class="flex w-1/3"
                        > -->
                        <label
                            for="table-search"
                            class="flex items-center mr-2 text-sm font-semibold"
                        >
                            Wholesaler
                        </label>
                        <t-select
                            v-model="filterBy"
                            placeholder="All"
                            :options="wholesalers"
                            text-attribute="name"
                            value-attribute="id"
                            class="text-sm"
                        />
                        <!-- </div> -->
                    </div>
                </div>

                <div
                    class="w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-none shadow-md"
                >
                    <div class="overflow-x-auto">
                        <table
                            class="min-w-[700px] w-full table-auto text-sm sm:text-base text-left text-gray-700 dark:text-gray-300"
                        >
                            <thead class="bg-gray-100 dark:bg-gray-700 text-sm font-semibold">
                                <tr>
                                    <th class="px-4 py-3">#</th>
                                    <th
                                        v-if="!isWholesaler"
                                        class="px-4 py-3"
                                    >
                                        WHOLESALER
                                    </th>
                                    <th class="px-4 py-3">PRODUCT</th>
                                    <th class="px-4 py-3">STOCK</th>
                                    <th class="px-4 py-3">CREATED</th>
                                    <th class="px-4 py-3">ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(row, rowIndex) in products.data">
                                    <tr
                                        :class="[
                                            'border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition duration-200',
                                        ]"
                                    >
                                        <td class="px-4 py-3">{{ rowIndex + 1 + (currentPage - 1) * perPage }}</td>
                                        <td
                                            v-if="!isWholesaler"
                                            :class="[tdClass]"
                                        >
                                            {{ row.owner.name }}
                                        </td>
                                        <td class="px-4 py-3">
                                            {{ row.name }}
                                        </td>
                                        <td class="px-4 py-3">
                                            {{ row.available_stock }}
                                        </td>
                                        <td class="px-4 py-3">
                                            {{ row.created_at | dateLabel }}
                                        </td>
                                        <td class="px-4 py-3">
                                            <div class="relative inline-flex shadow-sm rounded-md overflow-visible">
                                                <!-- Primary Action -->
                                                <div v-if="!row.deleted_at">
                                                    <t-button
                                                        variant="success"
                                                        size="sm"
                                                        @click="goto('stockchange.productScopedIndex', row.id)"
                                                    >
                                                        View
                                                    </t-button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <tr
                                    v-if="!products.data.length"
                                    class="text-center"
                                >
                                    <td
                                        colspan="6"
                                        class="px-4 py-4 text-gray-500 dark:text-gray-400"
                                    >
                                        {{ $t('LBL_DATA_FOUND') }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div
                        v-if="products.data.length"
                        class="flex justify-center items-center bg-gray-100 dark:bg-gray-800 px-4 py-4 border-t dark:border-gray-700"
                    >
                        <t-pagination
                            v-model="currentPage"
                            variant="rounded"
                            :total-items="totalRows"
                            :per-page="perPage"
                            :limit="limit"
                            :disabled="!products.data.length"
                            @change="fetchPageData"
                        />
                    </div>
                    <p class="sm:hidden text-xs text-center text-gray-500 py-2">
                        ↔ Swipe left/right to scroll the table
                    </p>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import _ from 'lodash';
    import AppLayout from '@/Layouts/AppLayout.vue';
    import ViewIcon from '@/Components/Icons/ViewIcon.vue';

    export default {
        name: 'StockChangesProducts',

        components: {
            AppLayout,
            ViewIcon,
        },

        props: {
            products: {
                type: Object,
                required: true,
            },
            wholesalers: {
                type: Array,
                required: true,
            },
            filteredBy: {
                type: String,
                default: null,
            },
            oldSearch: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                filterBy: this.filteredBy ? parseInt(this.filteredBy) : null,
                tableHeaders: ['#', 'WHOLESALER', 'PRODUCT', 'CURRENT STOCK', 'CREATED', 'ACTIONS'],
                currentPage: null,
                limit: 5,
                perPage: this.products.per_page,
                totalRows: this.products.total,
                search: this.oldSearch,
                disabled: false,
            };
        },

        computed: {
            currentTableHeaders() {
                if (this.isWholesaler) {
                    return this.tableHeaders.filter((each) => each !== 'WHOLESALER');
                }
                return this.tableHeaders;
            },
        },

        watch: {
            filterBy: {
                handler() {
                    this.filterByWholesaler();
                },
            },

            search: {
                handler() {
                    this.debounceFetchSearchResults();
                },
            },
        },

        created() {
            this.currentPage = this.products.current_page;
            this.debounceFetchSearchResults = _.debounce(this.fetchSearchResults, 1000);
        },

        mounted() {
            this.disabled = this.bills.data.length === 0;
        },

        methods: {
            filterByWholesaler() {
                this.$inertia.get(
                    route('stockchange.index', {
                        filterBy: this.filterBy,
                    }),
                );
            },

            fetchSearchResults() {
                this.$inertia.get(
                    route('stockchange.index', {
                        filterBy: this.filterBy,
                        search: this.search,
                    }),
                );
            },

            fetchPageData(newPage) {
                this.$inertia.get(
                    route('stockchange.index', {
                        page: newPage,
                        filterBy: this.filterBy ? this.filterBy : '',
                    }),
                );
            },
        },
    };
</script>
